module.exports = {
    PAYMENT_METHOD_CARD: 'search_payment_method_card',
    PAYMENT_METHOD_MOBILE: 'search_payment_method_mobile',
    PAYMENT_METHOD_MAESTRO: 'search_payment_method_maestro',
};
